module.exports = __webpack_public_path__ + "static/media/Table1_After.8ad2e314.jpg";